export default __webpack_public_path__ + "web/react/components/app-download-promo/image-assets/DESKTOP.20e7efb18145a303fdfb95a76c1948ea.jpg";